module.exports = __webpack_public_path__ + "img/road.f4acbea4.svg";